const PREVIOUS_ROUTE_KEY = 'previousRoute';
const LAST_VISTED_ROUTE_KEY = 'lastVisitedRoute';

export const setPreviousRoute = (route: string): void => {
  sessionStorage.setItem(PREVIOUS_ROUTE_KEY, route);
};

export const setLastVisitedRoute = (route: string): void => {
  sessionStorage.setItem(LAST_VISTED_ROUTE_KEY, route);
};

export const getPreviousRoute = (): string => {
  return sessionStorage.getItem(PREVIOUS_ROUTE_KEY) || '';
};

export const getLastVisitedRoute = (): string => {
  return sessionStorage.getItem(LAST_VISTED_ROUTE_KEY) || '';
};
